import React from 'react';

const messages = {
	'ari:cloud:confluence::site/a436116f-02ce-4520-8fbb-7301462a1674': 'Hello',
	'ari:cloud:confluence::site/DUMMY-158c8204-ff3b-47c2-adbb-a0906ccc722b': 'Product Fabric',
	'ari:cloud:confluence::site/4d7f3154-1d7b-4a16-b859-f1904a19b11f': 'Security Team',
	'ari:cloud:confluence::site/12e73ff5-8b07-4b31-be8e-67ee0666fc43': 'Software Teams',
};

type SearchResultSiteNameProps = {
	cloudARI: string;
};

export const SearchResultSiteName = ({
	cloudARI,
}: SearchResultSiteNameProps): React.JSX.Element | null => {
	const siteId = cloudARI.split(':')[3];
	const messageKey = `ari:cloud:confluence::site/${siteId}`;
	const message = messages[messageKey as keyof typeof messages];

	if (!message) {
		return null;
	}

	return <>{message}</>;
};
